import StorePointTransaction from './StorePointTransaction';

export default StorePointTransaction;
